import { fromJS } from 'immutable';
import moment from 'moment'
import _ from "lodash"
import {
	SET_CONTAINI,
	GET_CONTAINI, GET_DESTINATARIOS, GET_ITEMS, GET_CASHBOOK, ADD_MOV, GET_INVENTARY, GET_SUPPLIERS, GET_CLIENTS, GET_MEDIOS, GET_MONEDAS, GET_RUBROS, GET_SUBRUBROS, GET_SOURCE,
	ADD_CLIENT,
	ADD_SUPPLIER,
	ADD_ITEM,
	ADD_MEDIO,
	ADD_MONEDA,
	ADD_RUBRO,
	ADD_SUBRUBRO,
	ADD_SOURCE,
	UPDATE_CLIENT,
	UPDATE_SUPPLIER,
	UPDATE_ITEM,
	UPDATE_MEDIO,
	UPDATE_MONEDA,
	UPDATE_RUBRO,
	UPDATE_SUBRUBRO,
	UPDATE_SOURCE,
	DEL_MOV,
	DEL_CLIENT,
	DEL_SUPPLIER,
	DEL_ITEM,
	DEL_MEDIO,
	DEL_MONEDA,
	DEL_RUBRO,
	DEL_SUBRUBRO,
	DEL_SOURCE,
	UPDATE_DATO,
	GET_CUERPO,
	UPDATE_MOV,
	ADD_MOV_ITEM,
	ADD_MOV_PAGO,
	UPDATE_MOV_ITEM,
	UPDATE_MOV_PAGO,
	DEL_MOV_ITEM,
	DEL_MOV_PAGO,
	ADD_STOCK,
	GET_STOCK,
	GET_CAJA,
	GET_CAJA_MOVS,
	GET_HOTELES,
	GET_INFORME,
	GET_COMISIONES,
	GET_DASHINI,
	GET_MEAN_PAYMENTS,
	GET_RESUMEN,
	GET_RECEIPTS,
	GET_YOGA,
	GET_INSTRUCTORS,
	ADD_INSTRUCTORS,
	UPDATE_INSTRUCTORS,
	DEL_INSTRUCTORS,
	GET_USUARIOS,
	ADD_USUARIO,
	UPDATE_USUARIO,
	GET_TAXES,
	ADD_TAX,
	UPDATE_TAX,
	DEL_TAX,
	GET_HISTORIAL_CAJA,
	ADD_BNUMBERS,
	UPDATE_BNUMBERS,
	GET_BNUMBERS,
	GET_ENQUI_REPORT,
	GET_ASSET,
	ADD_ASSET,
	UPDATE_ASSET,
	DEL_ASSET,
	GET_ASSETS_TYPE,
	ADD_ASSETS_TYPE,
	UPDATE_ASSETS_TYPE,
	DEL_ASSETS_TYPE,
	LIMPIA_CAJA
} from "../actions/constants";

const initialTodos = {
	cashbook: [],
	cashbook_turno: [],
	comisiones: [],
	inventary: [],
	informe: [],
	pagos: [],
	sources: [],
	clients: [],
	suppliers: [],
	instructors: [],
	items: [],
	mov: {},
	cuerpo_items: [],
	cuerpo_pagos: [],
	cuerpo_docs: [],
	destinatarios: [],
	monedas: [],
	monedas_object: {},
	medios_pago: [],
	medios_pago_object: {},
	destinos: [],
	usuarios: [],
	usuarios_admin: [],
	hoteles: [],
	rubros: [],
	subrubros: [],
	contador: 0,
	contador_datos_ini: 0,
	stock: [],
	caja: null,
	caja_movs: null,
	mean_payments: [],
	resumen: [],
	inicio: 0,
	receipts: [],
	yoga: [],
	taxes: [],
	historial_caja: [],
	bnumbers: [],
	contador_stock: 0,
	countries: [
		"United States",
		"Canada",
		"Afghanistan",
		"Albania",
		"Algeria",
		"American Samoa",
		"Andorra",
		"Angola",
		"Anguilla",
		"Antarctica",
		"Antigua and/or Barbuda",
		"Argentina",
		"Armenia",
		"Aruba",
		"Australia",
		"Austria",
		"Azerbaijan",
		"Bahamas",
		"Bahrain",
		"Bangladesh",
		"Barbados",
		"Belarus",
		"Belgium",
		"Belize",
		"Benin",
		"Bermuda",
		"Bhutan",
		"Bolivia",
		"Bosnia and Herzegovina",
		"Botswana",
		"Bouvet Island",
		"Brazil",
		"British Indian Ocean Territory",
		"Brunei Darussalam",
		"Bulgaria",
		"Burkina Faso",
		"Burundi",
		"Cambodia",
		"Cameroon",
		"Cape Verde",
		"Cayman Islands",
		"Central African Republic",
		"Chad",
		"Chile",
		"China",
		"Christmas Island",
		"Cocos (Keeling) Islands",
		"Colombia",
		"Comoros",
		"Congo",
		"Cook Islands",
		"Costa Rica",
		"Croatia (Hrvatska)",
		"Cuba",
		"Cyprus",
		"Czech Republic",
		"Denmark",
		"Djibouti",
		"Dominica",
		"Dominican Republic",
		"East Timor",
		"Ecudaor",
		"Egypt",
		"El Salvador",
		"Equatorial Guinea",
		"Eritrea",
		"Estonia",
		"Ethiopia",
		"Falkland Islands (Malvinas)",
		"Faroe Islands",
		"Fiji",
		"Finland",
		"France",
		"France, Metropolitan",
		"French Guiana",
		"French Polynesia",
		"French Southern Territories",
		"Gabon",
		"Gambia",
		"Georgia",
		"Germany",
		"Ghana",
		"Gibraltar",
		"Greece",
		"Greenland",
		"Grenada",
		"Guadeloupe",
		"Guam",
		"Guatemala",
		"Guinea",
		"Guinea-Bissau",
		"Guyana",
		"Haiti",
		"Heard and Mc Donald Islands",
		"Honduras",
		"Hong Kong",
		"Hungary",
		"Iceland",
		"India",
		"Indonesia",
		"Iran (Islamic Republic of)",
		"Iraq",
		"Ireland",
		"Israel",
		"Italy",
		"Ivory Coast",
		"Jamaica",
		"Japan",
		"Jordan",
		"Kazakhstan",
		"Kenya",
		"Kiribati",
		"Korea, Democratic People's Republic of",
		"Korea, Republic of",
		"Kosovo",
		"Kuwait",
		"Kyrgyzstan",
		"Lao People's Democratic Republic",
		"Latvia",
		"Lebanon",
		"Lesotho",
		"Liberia",
		"Libyan Arab Jamahiriya",
		"Liechtenstein",
		"Lithuania",
		"Luxembourg",
		"Macau",
		"Macedonia",
		"Madagascar",
		"Malawi",
		"Malaysia",
		"Maldives",
		"Mali",
		"Malta",
		"Marshall Islands",
		"Martinique",
		"Mauritania",
		"Mauritius",
		"Mayotte",
		"Mexico",
		"Micronesia, Federated States of",
		"Moldova, Republic of",
		"Monaco",
		"Mongolia",
		"Montserrat",
		"Morocco",
		"Mozambique",
		"Myanmar",
		"Namibia",
		"Nauru",
		"Nepal",
		"Netherlands",
		"Netherlands Antilles",
		"New Caledonia",
		"New Zealand",
		"Nicaragua",
		"Niger",
		"Nigeria",
		"Niue",
		"Norfork Island",
		"Northern Mariana Islands",
		"Norway",
		"Oman",
		"Pakistan",
		"Palau",
		"Panama",
		"Papua New Guinea",
		"Paraguay",
		"Peru",
		"Philippines",
		"Pitcairn",
		"Poland",
		"Portugal",
		"Puerto Rico",
		"Qatar",
		"Reunion",
		"Romania",
		"Russian Federation",
		"Rwanda",
		"Saint Kitts and Nevis",
		"Saint Lucia",
		"Saint Vincent and the Grenadines",
		"Samoa",
		"San Marino",
		"Sao Tome and Principe",
		"Saudi Arabia",
		"Senegal",
		"Seychelles",
		"Sierra Leone",
		"Singapore",
		"Slovakia",
		"Slovenia",
		"Solomon Islands",
		"Somalia",
		"South Africa",
		"South Georgia South Sandwich Islands",
		"South Sudan",
		"Spain",
		"Sri Lanka",
		"St. Helena",
		"St. Pierre and Miquelon",
		"Sudan",
		"Suriname",
		"Svalbarn and Jan Mayen Islands",
		"Swaziland",
		"Sweden",
		"Switzerland",
		"Syrian Arab Republic",
		"Taiwan",
		"Tajikistan",
		"Tanzania, United Republic of",
		"Thailand",
		"Togo",
		"Tokelau",
		"Tonga",
		"Trinidad and Tobago",
		"Tunisia",
		"Turkey",
		"Turkmenistan",
		"Turks and Caicos Islands",
		"Tuvalu",
		"Uganda",
		"Ukraine",
		"United Arab Emirates",
		"United Kingdom",
		"United States minor outlying islands",
		"Uruguay",
		"Uzbekistan",
		"Vanuatu",
		"Vatican City State",
		"Venezuela",
		"Vietnam",
		"Virigan Islands (British)",
		"Virgin Islands (U.S.)",
		"Wallis and Futuna Islands",
		"Western Sahara",
		"Yemen",
		"Yugoslavia",
		"Zaire",
		"Zambia",
		"Zimbabwe",
	],
	enqui_report: [],
	assets: [],
	assets_tipos: [],
	hours_types: [],
	tickets_lista:[],
	tickets_object:{},
	locations:[],
};

const conta = (state = initialTodos, action) => {
	var newState = Object.assign({}, state);
	const datos = fromJS(newState)
	//console.log(action.type)
	switch (action.type) {
		case SET_CONTAINI:
			console.log(action)
			const types_ini = action.payload.hours_type.map(item => {
				item.monto=0
				item.monto_ordinarias=0
				item.monto_extras=0
				item.cantidad=0
				item.cantidad_ordinarias=0
				item.cantidad_extras=0
				item.valor_hs_ordinaria=0
				item.valor_hs_extra=0
				item.dias=[]
				item.contratos_id=[]
                item.contratos_valor_hs=[]
				return item
			})
			const medios_pago_object = action.payload.medios.reduce((acc, medios_pago) => {
				acc[medios_pago.id] = medios_pago;
				return acc;
			},{})
			const monedas_object =action.payload.monedas.reduce((acc, moneda) => {
				acc[moneda.id] = moneda;
				return acc;
			},{})

			const tickets_object =action.payload.tickets_lista.reduce((acc, ticket) => {
				acc[ticket.id] = ticket;
				return acc;
			},{})

			const destinosIni = datos.updateIn(["destinos"], (value) => action.payload.destinos);
			const hotelesIni = destinosIni.updateIn(["hoteles"], (value) => action.payload.hoteles);
			const monedasIni = hotelesIni.updateIn(["monedas"], (value) => _.sortBy(action.payload.monedas, o => o.orden));
			const monedasObjectIni = monedasIni.updateIn(["monedas_object"], (value) =>monedas_object);
			const mediosPagoIni = monedasObjectIni.updateIn(["medios_pago"], (value) => _.sortBy(action.payload.medios, o => o.orden))
			const mediosPagoObejctIni = mediosPagoIni.updateIn(["medios_pago_object"], (value) => medios_pago_object)
			const usuariosIni = mediosPagoObejctIni.updateIn(["usuarios"], (value) => action.payload.users);
			const rubrosIni = usuariosIni.updateIn(["rubros"], (value) => action.payload.categories);
			const sourceIni = rubrosIni.updateIn(["sources"], (value) => action.payload.sources);
			const taxesIni = sourceIni.updateIn(["taxes"], (value) => action.payload.taxes);
			const hoursTypesIni = taxesIni.updateIn(["hours_types"], (value) => types_ini);
			const ticketsListaIni = hoursTypesIni.updateIn(["tickets_lista"], (value) => action.payload.tickets_lista);
			const ticketsObjectIni = ticketsListaIni.updateIn(["tickets_object"], (value) => tickets_object);

			const locationsIni = ticketsObjectIni.updateIn(["locations"], (value) => action.payload.locations_lista);
			const inicioIni = locationsIni.updateIn(["inicio"], (value) => moment().unix());
			var countNew = inicioIni.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_CONTAINI:
			const types = action.payload.hours_type.map(item => {
				item.monto=0
				item.monto_ordinarias=0
				item.monto_extras=0
				item.cantidad=0
				item.cantidad_ordinarias=0
				item.cantidad_extras=0
				item.valor_hs_ordinaria=0
				item.valor_hs_extra=0
				item.dias=[]
				item.contratos_id=[]
                item.contratos_valor_hs=[]
				return item
			})
			
			const cajaIniNew = datos.updateIn(["caja"], (value) => action.caja);
			const cajaIniMovsNew = cajaIniNew.updateIn(["caja_movs"], (value) => action.caja_movs);
			const cajaIniMovsCashNew = cajaIniMovsNew.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movsCashNew = cajaIniMovsCashNew.updateIn(["cashbook"], (value) => action.movs);
			const destinosNew = movsCashNew.updateIn(["destinos"], (value) => action.payload.destinos);
			const hotelesNew = destinosNew.updateIn(["hoteles"], (value) => action.payload.hoteles);
			const monedasNew = hotelesNew.updateIn(["monedas"], (value) => _.sortBy(action.payload.monedas, o => o.orden));
			const mediosPagoNew = monedasNew.updateIn(["medios_pago"], (value) => _.sortBy(action.payload.medios, o => o.orden))
			const usuariosNew = mediosPagoNew.updateIn(["usuarios"], (value) => action.payload.users);
			const rubrosNew = usuariosNew.updateIn(["rubros"], (value) => action.payload.categories);
			const sourceNew = rubrosNew.updateIn(["sources"], (value) => action.payload.sources);
			const taxesNew = sourceNew.updateIn(["taxes"], (value) => action.payload.taxes);
			const hoursTypesNew = taxesNew.updateIn(["hours_types"], (value) => types);
			const subrubrosIniNew = hoursTypesNew.updateIn(["subrubros"], (value) => action.payload.subrubros ?? value);
			const inicioNew = subrubrosIniNew.updateIn(["inicio"], (value) => moment().unix());
			var countNew = inicioNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_DASHINI:
			const types_dash = action.payload.hours_type.map(item => {
				item.monto=0
				item.monto_ordinarias=0
				item.monto_extras=0
				item.cantidad=0
				item.cantidad_ordinarias=0
				item.cantidad_extras=0
				item.valor_hs_ordinaria=0
				item.valor_hs_extra=0
				item.dias=[]
				item.contratos_id=[]
                item.contratos_valor_hs=[]
				return item
			})
			const destinosDashNew = datos.updateIn(["destinos"], (value) => action.payload.destinos);
			const hotelesDashNew = destinosDashNew.updateIn(["hoteles"], (value) => action.payload.hoteles);
			const monedasDashNew = hotelesDashNew.updateIn(["monedas"], (value) => _.sortBy(action.payload.monedas, o => o.orden));
			const mediosPagoDashNew = monedasDashNew.updateIn(["medios_pago"], (value) => _.sortBy(action.payload.medios, o => o.orden))
			const usuariosDashNew = mediosPagoDashNew.updateIn(["usuarios"], (value) => action.payload.users);
			const rubrosDashNew = usuariosDashNew.updateIn(["rubros"], (value) => action.payload.categories);
			const sourceDashNew = rubrosDashNew.updateIn(["sources"], (value) => action.payload.sources);
			const taxesDashNew = sourceDashNew.updateIn(["taxes"], (value) => action.payload.taxes);
			const hoursDashTypesNew = taxesDashNew.updateIn(["hours_types"], (value) => types_dash)
			var countNew = hoursDashTypesNew.updateIn(["contador_datos_ini"], (value) => moment().unix());
			return countNew.toJS();

			case LIMPIA_CAJA:
				const limpiaCajaGetNew = datos.updateIn(["caja"], (value) => null);
				const limpiaCajaMovsResetNew = limpiaCajaGetNew.updateIn(["caja_movs"], (value) => []);
				const limpiaCajaMovsCashResetNew = limpiaCajaMovsResetNew.updateIn(["caja_movs_cash"], (value) => []);
				return limpiaCajaMovsCashResetNew.toJS();

		case GET_ENQUI_REPORT:
			const enquiRepNew = datos.updateIn(["enqui_report"], (value) => action.payload);
			return enquiRepNew.toJS();

		case GET_BNUMBERS:
			const bnumebrsNew = datos.updateIn(["bnumbers"], (value) => action.payload);
			return bnumebrsNew.toJS();

		case ADD_BNUMBERS:
			const bnumberAddNew = datos.updateIn(["bnumbers"], (value) => action.payload);
			var countNew = bnumberAddNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_BNUMBERS:
			const bnumberUpNew = datos.updateIn(["bnumbers"], (value) => action.payload);
			var countNew = bnumberUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();


		case GET_HISTORIAL_CAJA:
			var historialCaja = datos.updateIn(["historial_caja"], (value) => action.payload);
			return historialCaja.toJS();

		case ADD_MOV:
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const cajaRefreshtNew = cajaMovsCashUpdate.updateIn(["caja"], (value) => action.caja);
			const cajaMovsRefreshNew = cajaRefreshtNew.updateIn(["caja_movs"], (value) => action.movs);
			const movAddNew = cajaMovsRefreshNew.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movAddNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_DESTINATARIOS:
			return state;

		case GET_RESUMEN:
			const resumenNew = datos.updateIn(["resumen"], (value) => action.payload);
			var countNew = resumenNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_YOGA:
			const yogaNew = datos.updateIn(["yoga"], (value) => action.payload);
			var countNew = yogaNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_HOTELES:
			const hNew = datos.updateIn(["hoteles"], (value) => action.payload);
			var countNew = hNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_MEAN_PAYMENTS:
			const meanNew = datos.updateIn(["mean_payments"], (value) => action.payload);
			var countNew = meanNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_COMISIONES:
			const comiNew = datos.updateIn(["comisiones"], (value) => action.payload);
			return comiNew.toJS();

		case GET_ITEMS:
			const itemsNew = datos.updateIn(["items"], (value) => action.payload);
			var countNew = itemsNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_USUARIOS:
			const usuariosAdminNew = datos.updateIn(["usuarios_admin"], (value) => action.payload);
			var countNew = usuariosAdminNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_SUPPLIERS:
			const supliersNew = datos.updateIn(["suppliers"], (value) => action.payload);
			var countNew = supliersNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();
		case GET_CLIENTS:
			const clientsNew = datos.updateIn(["clients"], (value) => action.payload);
			var countNew = clientsNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_SOURCE:
			const sourcesNew = datos.updateIn(["sources"], (value) => action.payload);
			var countNew = sourcesNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_MEDIOS:
			const mediosNew = datos.updateIn(["medios_pago"], (value) => action.payload);
			var countNew = mediosNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();
		case GET_MONEDAS:
			console.log(action.payload);
			const Add = datos.updateIn(["monedas"], (value) => action.payload);
			var countNew = Add.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_RUBROS:
			const rubrosNew2 = datos.updateIn(["rubros"], (value) => action.payload);
			var countNew = rubrosNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_SUBRUBROS:
			const subrubrosNew2 = datos.updateIn(["subrubros"], (value) => action.payload);
			var countNew = subrubrosNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_INFORME:
			const informeNew = datos.updateIn(["informe"], (value) => action.payload.data);
			const informePagosNew = informeNew.updateIn(["pagos"], (value) => action.payload.data_pagos);
			var countNew = informePagosNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_CLIENT:
			var data_temp = Object.assign([], state.clients);
			action.datos_send.id = action.payload.insertId;
			data_temp.push(action.datos_send);
			const clientsNew2 = datos.updateIn(["clients"], (value) => data_temp);
			var countNew = clientsNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_CLIENT:
			var index = datos.get("clients").findIndex((item) => item.get("id") == action.datos_send.id);
			const clientsUpNew = datos.updateIn(["clients", index], (value) => action.datos_send);
			var countNew = clientsUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_CLIENT:
			var index = datos.get("clients").findIndex((item) => item.get("id") == action.id);
			const clientDelNew = datos.deleteIn(["clients", index]);
			var countNew = clientDelNew.updateIn(["contador"], (value) => moment().unix());
			return rubroDelNew.toJS();

		case ADD_SOURCE:
			var data_temp = Object.assign([], state.sources);
			action.datos_send.id = action.payload.insertId;
			data_temp.push(action.datos_send);
			const sourceNew2 = datos.updateIn(["sources"], (value) => data_temp);
			var countNew = sourceNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_SOURCE:
			var index = datos.get("sources").findIndex((item) => item.get("id") == action.datos_send.id);
			const sourceUpNew = datos.updateIn(["sources", index], (value) => action.datos_send);
			var countNew = sourceUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_SOURCE:
			var index = datos.get("sources").findIndex((item) => item.get("id") == action.id);
			const sourceDelNew = datos.deleteIn(["sources", index]);
			var countNew = sourceDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_TAXES:
			const taxesGetNew = datos.updateIn(["taxes"], (value) => action.payload);
			var countNew = taxesGetNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();


		case ADD_TAX:
			const taxAddNew = datos.updateIn(["taxes"], (value) => action.payload);
			var countNew = taxAddNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_TAX:
			const taxUpNew = datos.updateIn(["taxes"], (value) => action.payload);
			var countNew = taxUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();


		case DEL_TAX:
			const taxDelNew = datos.updateIn(["taxes"], (value) => action.payload);
			var countNew = taxDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();


		case ADD_SUPPLIER:
			var data_temp = Object.assign([], state.suppliers);
			action.datos_send.id = action.payload.insertId;
			data_temp.push(action.datos_send);
			const suppliersNew2 = datos.updateIn(["suppliers"], (value) => data_temp);
			var countNew = suppliersNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_SUPPLIER:
			var index = datos.get("suppliers").findIndex((item) => item.get("id") == action.datos_send.id);
			const suppliersUpNew = datos.updateIn(["suppliers", index], (value) => action.datos_send);
			var countNew = suppliersUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_SUPPLIER:
			var index = datos.get("suppliers").findIndex((item) => item.get("id") == action.id);
			const supplierDelNew = datos.deleteIn(["suppliers", index]);
			var countNew = supplierDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_ITEM:
			//var data_temp = Object.assign([], state.items);
			//action.datos_send.id = action.payload.insertId;
			//data_temp.push(action.datos_send);
			//const itemsNew2 = datos.updateIn(["items"], (value) => data_temp);
			const itemsNew2 = datos.updateIn(["items"], (value) => action.datos_lista.data.data);
			//var countNew = itemsNew2.updateIn(["contador"], (value) => moment().unix());
			return itemsNew2.toJS();

		case UPDATE_ITEM:
			const itemsUpNew = datos.updateIn(["items"], (value) => action.datos_lista.data.data);
			//var index = datos.get("items").findIndex((item) => item.get("id") == action.datos_send.id);
			//const itemsUpNew = datos.updateIn(["items", index], (value) => action.datos_send);
			//var countNew = itemsUpNew.updateIn(["contador"], (value) => moment().unix());
			return itemsUpNew.toJS();

		case DEL_ITEM:
			//var index = datos.get("items").findIndex((item) => item.get("id") == action.id);
			//const itemsDelNew = datos.deleteIn(["items", index]);
			//var countNew = itemsDelNew.updateIn(["contador"], (value) => moment().unix());
			const itemsDelNew = datos.updateIn(["items"], (value) => action.datos_lista.data.data);
			return itemsDelNew.toJS();

		case ADD_USUARIO:
			const usuariosNew2 = datos.updateIn(["usuarios_admin"], (value) => action.payload);
			var countNew = usuariosNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_USUARIO:
			const usuarioUpNew = datos.updateIn(["usuarios_admin"], (value) => action.payload);
			var countNew = usuarioUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_MEDIO:
			var data_temp = Object.assign([], state.medios_pago);
			action.datos_send.id = action.payload.data.insertId;
			data_temp.push(action.datos_send);
			const mediosNew2 = datos.updateIn(["medios_pago"], (value) => data_temp);
			var countNew = mediosNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_MEDIO:
			var index = datos.get("medios_pago").findIndex((item) => item.get("id") == action.datos_send.id);
			const mediosUpNew = datos.updateIn(["medios_pago", index], (value) => action.datos_send);
			var countNew = mediosUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_MEDIO:
			var index = datos.get("medios_pago").findIndex((item) => item.get("id") == action.id);
			const mediosDelNew = datos.deleteIn(["medios_pago", index]);
			var countNew = mediosDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_MONEDA:
			var data_temp = Object.assign([], state.monedas);
			action.datos_send.id = action.payload.insertId;
			data_temp.push(action.datos_send);
			const monedasAddNew2 = datos.updateIn(["monedas"], (value) => data_temp);
			var countNew = monedasAddNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_MONEDA:
			var index = datos.get("monedas").findIndex((item) => item.get("id") == action.datos_send.id);
			const monedasUpNew = datos.updateIn(["monedas", index], (value) => action.datos_send);
			var countNew = monedasUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_MONEDA:
			var index = datos.get("monedas").findIndex((item) => item.get("id") == action.id);
			const monedasDelNew = datos.deleteIn(["monedas", index]);
			var countNew = monedasDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_RUBRO:
			const rubrosAddNew2 = datos.updateIn(["rubros"], (value) => action.datos_lista.data.data);
			var countNew = rubrosAddNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_RUBRO:
			var index = datos.get("rubros").findIndex((item) => item.get("id") == action.datos_send.id);
			const rubrosUpNew = datos.updateIn(["rubros"], (value) => action.datos_lista.data.data);
			var countNew = rubrosUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_RUBRO:
			const rubroDelNew = datos.updateIn(["rubros"], (value) => action.datos_lista.data.data);
			var countNew = rubroDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_SUBRUBRO:
			const subrubrosAddNew2 = datos.updateIn(["subrubros"], (value) => action.datos_lista.data.data);
			var countNew = subrubrosAddNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_SUBRUBRO:
			const subrubrosUpNew = datos.updateIn(["subrubros"], (value) => action.datos_lista.data.data);
			var countNew = subrubrosUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_SUBRUBRO:
			const subrubroDelNew = datos.updateIn(["subrubros"], (value) => action.datos_lista.data.data);
			var countNew = subrubroDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_CASHBOOK:
			const cajaBookNew = datos.updateIn(["caja"], (value) => action.caja);
			const cajaMovsNew2 = cajaBookNew.updateIn(["caja_movs"], (value) => action.movs);
			const cashbookNew = cajaMovsNew2.updateIn(["cashbook"], (value) => action.payload);
			var countNew = cashbookNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_INVENTARY:
			const inventaryNew = datos.updateIn(["inventary"], (value) => action.payload);
			var countNew = inventaryNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_RECEIPTS:
			const receiptsNew = datos.updateIn(["receipts"], (value) => action.payload);
			return receiptsNew.toJS();

		case UPDATE_DATO:
			var index = datos.get(action.datos_send.tipo).findIndex((item) => item.get("id") == action.datos_send.id);
			var data_temp = Object.assign({}, state[action.datos_send.tipo][index]);
			data_temp[action.datos_send.campo] = action.datos_send.valor
			const datoUpNew = datos.updateIn([action.datos_send.tipo, index], (value) => data_temp);
			var countNew = datoUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_CUERPO:
			const cuerpoItemsNew = datos.updateIn(["cuerpo_items"], (value) => action.payload.items);
			const cuerpoPagosNew = cuerpoItemsNew.updateIn(["cuerpo_pagos"], (value) => action.payload.pagos);
			const cuerpoDocsNew = cuerpoPagosNew.updateIn(["cuerpo_docs"], (value) => action.payload.docs);
			//var countNew = cuerpoPagosNew.updateIn(["contador"], (value) => moment().unix());
			return cuerpoDocsNew.toJS();

		case UPDATE_MOV:
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movUpNew = cajaMovsCashUpdate.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_MOV_ITEM:
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movItemAddNew = cajaMovsCashUpdate.updateIn(["cuerpo_items"], (value) => action.payload_cuerpo);
			const movItemAddCashNew = movItemAddNew.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movItemAddCashNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_MOV_PAGO:
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movPagoAddNew = cajaMovsCashUpdate.updateIn(["cuerpo_pagos"], (value) => action.payload_cuerpo);
			const movPagoAddCashNew = movPagoAddNew.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movPagoAddCashNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_MOV_ITEM:
			const movItemUpNew = datos.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movItemUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_MOV_PAGO:
			const movPagoUpNew = datos.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movPagoUpNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_MOV:
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movDelNew = cajaMovsCashUpdate.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movDelNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_MOV_ITEM:
			var index = datos.get("cuerpo_items").findIndex((item) => item.get("id") == action.id);
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movItemDelNew = cajaMovsCashUpdate.deleteIn(["cuerpo_items", index]);
			const movItemDelCashNew = movItemDelNew.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movItemDelCashNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case DEL_MOV_PAGO:
			var index = datos.get("cuerpo_pagos").findIndex((item) => item.get("id") == action.id);
			var cajaUpdate = datos.updateIn(["caja"], (value) => action.caja);
			var cajaMovsUpdate = cajaUpdate.updateIn(["caja_movs"], (value) => action.caja_movs);
			var cajaMovsCashUpdate = cajaMovsUpdate.updateIn(["caja_movs_cash"], (value) => action.caja_movs_cash);
			const movPagoDelNew = cajaMovsCashUpdate.deleteIn(["cuerpo_pagos", index]);
			const movPagoDelCashNew = movPagoDelNew.updateIn(["cashbook"], (value) => action.payload);
			var countNew = movPagoDelCashNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_STOCK:
			const stockGetNew = datos.updateIn(["stock"], (value) => action.payload);
			var countNew = stockGetNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case ADD_STOCK:
			/*if(action.mov.mov<0 && action.mov.origen=="caja"){
				const limpiaCaja = datos.updateIn(["caja"], (value) => []);
				const limpiaCajaMovs = limpiaCaja.updateIn(["stock"], (value) => []);
				var countNew = limpiaCajaMovs.updateIn(["contador"], (value) => moment().unix());
				return countNew.toJS();
			}else{*/
			const stockAddNew = datos.updateIn(["stock"], (value) => action.payload);
			var countStockNew = stockAddNew.updateIn(["contador_stock"], (value) => moment().unix());
			var countNew = countStockNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();
		//}

		case GET_CAJA:
			const cajaGetNew = datos.updateIn(["caja"], (value) => action.payload);
			const cajaMovsResetNew = cajaGetNew.updateIn(["caja_movs"], (value) => action.movs);
			const cajaMovsCashResetNew = cajaMovsResetNew.updateIn(["caja_movs_cash"], (value) => action.movs_cash);
			var countNew = cajaMovsCashResetNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_CAJA_MOVS:
			const cajaMovsGetNew = datos.updateIn(["caja_movs"], (value) => action.payload);
			var countNew = cajaMovsGetNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_INSTRUCTORS:
			const instructorsGetNew = datos.updateIn(["instructors"], (value) => action.payload);
			return instructorsGetNew.toJS();

		case "SALE_CAJA":
			const cajaSaleNew = datos.updateIn(["caja"], (value) => []);
			const cajaMovsSaleNew = cajaSaleNew.updateIn(["caja_movs"], (value) => []);
			return cajaMovsSaleNew.toJS();

		case GET_ASSET:
			const assetsGetNew = datos.updateIn(["assets"], (value) => action.payload);
			return assetsGetNew.toJS();

		case ADD_ASSET:
			const assetsAddNew = datos.updateIn(["assets"], (value) => action.payload);
			return assetsAddNew.toJS();

		case UPDATE_ASSET:
			const assetsUpdateNew = datos.updateIn(["assets"], (value) => action.payload);
			return assetsUpdateNew.toJS();

		case DEL_ASSET:
			const assetsDelNew = datos.updateIn(["assets"], (value) => action.payload);
			return assetsDelNew.toJS();

		case GET_ASSETS_TYPE:
			const assetsTiposGetNew = datos.updateIn(["assets_tipos"], (value) => action.payload);
			return assetsTiposGetNew.toJS();

		case ADD_ASSETS_TYPE:
			const assetsTiposAddNew = datos.updateIn(["assets_tipos"], (value) => action.payload);
			return assetsTiposAddNew.toJS();

		case UPDATE_ASSETS_TYPE:
			const assetsTiposUpdateNew = datos.updateIn(["assets_tipos"], (value) => action.payload);
			return assetsTiposUpdateNew.toJS();

		case DEL_ASSETS_TYPE:
			const assetsTiposDelNew = datos.updateIn(["assets_tipos"], (value) => action.payload);
			return assetsTiposDelNew.toJS();

		default:
			return state;
	}
}

export default conta